import React, { FC, useContext } from 'react';

import { AppContext } from '../../containers/appContextContainer';
import { useTranslation } from '../../translations';
import PageTitle from './pageTitle';
import { PAGE_ROOT } from './pageUrl';
import ProgressCircle from './progressCircle';

interface Props {
    title: string;
    children: React.JSX.Element;
}

const PageCard: FC<Props> = ({ title, children }) => {
    const { pageName, pageCard } = useTranslation();
    const { pageOrder } = useContext(AppContext);
    const location = window.location.hash.replace('#', '').split('?')[0];
    const currentPage = location.length === 0 ? PAGE_ROOT : location;
    const nextPageIndex = pageOrder.findIndex((p) => p === currentPage) + 1;
    const nextPage = pageOrder[nextPageIndex];

    return (
        <div className="sgw-layout medium-centered-container">
            <div className="sgw-layout-item">
                <div className="column space-between-items margin-top-extra-large margin-bottom-larger">
                    <div className="row space-between-items">
                        <h1 className="typography-h1__light margin-bottom-small">{title}</h1>
                        <span>{`${pageCard.neste}: ${PageTitle(nextPage, pageName)}`}</span>
                    </div>
                    <ProgressCircle />
                </div>
                {children}
            </div>
        </div>
    );
};

export default PageCard;
